import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  // needLogin: false,
  needLogin: false,
};

export default {
  state,
  actions,
  getters,
  mutations,
};
